import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IInternationalCurrenciesState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IInternationalCurrenciesState = {
  list: [],
  isLoading: false,
};